/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { FormTypeChild } from './form-type-child.model';


export class FormType {
    id: string; // ecf001
    title: string; // ecf001
    children: FormTypeChild[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): FormType {
        if (!data) { return instance; }
        if (data.id != null) {instance.id = data.id; }
        if (data.title != null) {instance.title = data.title; }
        if (data.children != null) {
            instance.children = [];
            ([].concat(data.children)).forEach(occurrence => {
                instance.children.push(new FormTypeChild().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return FormType.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: FormType) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return FormType.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: FormType): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
